import { CHANGE_USER, SET_USER_SETTINGS } from './actions';

let defaultState = {
	name: '',
	userSettings: {}
};

export default function user(state = defaultState, action) {
	switch (action.type) {
		case CHANGE_USER:
			return Object.assign({}, state, {
				name: action.name
			});
		case SET_USER_SETTINGS:
			return {
				...state,
				userSettings: action.data.userSettings
			};
		default:
			return state;
	}
}
